import { Injectable } from '@angular/core';
import { User } from 'app/model/user';

@Injectable({ providedIn: 'root'})

export class UserContextService {

    private _user: User;

    get user(): User {
        return this._user;
    }

    set user(usuarioLogado: User) {
        this._user = usuarioLogado;
    }

}
